module.exports = __webpack_public_path__ + "img/sorting.7eae2053.png";